import { Analytics } from '@cobliteam/analytics';
import { DeviceType } from '@cobliteam/api-lib/src/__generated__/graphql';
import { MediaType } from '@cobliteam/common-types';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import Card, { CardContent, CardHeader } from '@cobliteam/ui/components/Card';
import { FormControl, FormField, FormItem, FormLabel, useFormContext } from '@cobliteam/ui/form';
import RadioGroupItem, { RadioGroup } from '@cobliteam/ui/form/Radio';
import { cn } from '@cobliteam/ui/utils';
import useMediaStore from '../../../store/useMediaStore';

const cards = [
  {
    type: MediaType.FOOTAGE_VIDEO,
    label: 'Vídeo de um trecho',
    src: 'https://static.cobli.co/videos/videoMinuto1.mp4',
  },
  {
    type: MediaType.TIMELAPSE,
    label: 'Resumo de um trecho (time-lapse)',
    src: 'https://static.cobli.co/videos/videoTimelapse2.mp4',
  },
];

const MediaTypeSelect = () => {
  const { getValues, setValue } = useFormContext();
  const vehicle = getValues('vehicle');

  const clearTimeline = useMediaStore((state) => state.clearTimeline);

  const { multiCamTimelapseRequests } = useFeatureFlags();
  const isMulticamTimelapseBlocked = vehicle?.deviceType === DeviceType.Multicam && !multiCamTimelapseRequests;

  return (
    <FormField name='mediaType'>
      {({ field }) => (
        <FormItem>
          <FormControl>
            <RadioGroup
              value={field.value}
              onValueChange={(value) => {
                Analytics.track('MediaRequestDialog - Select - Media Type', { type: value });

                field.onChange(value);
                clearTimeline();
                setValue('period', null);
              }}
              className='flex h-72 justify-center gap-4'
            >
              {cards.map(({ type, label, src }) => {
                const isDisabled = isMulticamTimelapseBlocked && type === MediaType.TIMELAPSE;

                return (
                  <FormItem key={type}>
                    <FormControl>
                      <label htmlFor={type}>
                        <Card
                          className={cn(
                            'size-full cursor-pointer transition-all',
                            field.value === type && 'ring-2 ring-primary',
                            isDisabled && 'pointer-events-none bg-gray-100 opacity-50 ring-transparent'
                          )}
                        >
                          <CardHeader className='flex-row items-center gap-2'>
                            <RadioGroupItem value={type} id={type} disabled={isDisabled} />
                            <FormLabel className='cursor-pointer'>{label}</FormLabel>
                          </CardHeader>
                          <CardContent>
                            <video loop autoPlay muted controls={false} className='w-[480px]'>
                              <source src={src} type='video/mp4' />
                            </video>
                          </CardContent>
                        </Card>
                      </label>
                    </FormControl>
                  </FormItem>
                );
              })}
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    </FormField>
  );
};

export default MediaTypeSelect;
